import React from "react";

const CoinPage = () => {
  return (
    <div>
      <h4>Coin page</h4>
    </div>
  );
};

export default CoinPage;
